(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("TableEditor", [], factory);
	else if(typeof exports === 'object')
		exports["TableEditor"] = factory();
	else
		root["TableEditor"] = factory();
})(this, function() {
return 